import React, { Component } from 'react';
import { Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import POApprovalDetails from '../POApproval/components/POApprovalDetails';
import POCreationDetails from './components/POCreationDetails';
//import TaxMaster from '../TaxMaster/components/taxMaster';
import "../../global.css";

class POCreation extends Component {
  constructor(props) {
    super(props);

    const searchParams = new URLSearchParams(window.location.search);
    const tab = searchParams.get('tab'); // e.g., "po_list" or "po_approval"
    console.log("TAB", tab);
    this.state = {
      /*activeTab: 'po_list'*/
      activeTab: tab === 'po_list' ? 'po_list' : tab === 'po_approval' ? 'po_approval' : 'po_list'
    };
  }

 
  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  render() {
    const { t } = this.props;
    const { activeTab } = this.state;

    return (
      <Container>
        
        <Row>
          <Col md={12} id="master_tab_container" className="master_tab_container">
           
                <Nav style={{backgroundColor: '#fff', marginBottom: 6, paddingLeft: 0}} tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'po_list' })}
                      style={activeTab === 'po_list' ? { backgroundColor: '#FEF1CC', margin: 0 } : {}}
                      onClick={() => this.toggleTab('po_list')}
                    >
                      PO List
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'po_approval' })}
                      style={activeTab === 'po_approval' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                      onClick={() => this.toggleTab('po_approval')}
                    >
                      PO Approval
                    </NavLink>
                  </NavItem>

                </Nav>
              
          </Col>
        </Row>

        
        <Row>
          <Col md={12}>
           
                {activeTab === 'po_list' ? <POCreationDetails/> : activeTab === 'po_approval' ? <POApprovalDetails/> : ""}
             
          </Col>
        </Row>
      </Container>
    );
  }
}

POCreation.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(POCreation);